import { type ComponentType, lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import {
  cashflowPriceAuditControl,
  cashflowCheckoutDiscrepancyAuditControl,
  cashflowTransactionIntegrityAuditControl,
} from '../access-control/cashflowAdminAccess.configuration'

const CashflowPriceAuditLandingPage = lazy(
  () => import('../pages/price-audit-landing/CashflowPriceAuditLandingPage')
)
const CashflowPriceAuditDetailsPage = lazy(
  () => import('../pages/price-audit-details/CashflowPriceAuditDetailsPage')
)

const CashflowPriceAuditFeedbackPage = lazy(
  () => import('../pages/price-audit-feedback/CashflowPriceAuditFeedbackPage')
)
const CashflowCheckoutDiscrepancyLandingPage = lazy(
  () => import('../pages/checkout-discrepancy/CheckoutDiscrepancyLandingPage')
)
const CashflowCheckoutDiscrepancyDetailsPage = lazy(
  () => import('../pages/checkout-discrepancy/CheckoutDiscrepancyDetailsPage')
)
const TransactionIntegrityLandingPage = lazy(
  () => import('../pages/transaction-integrity/TransactionIntegrityLandingPage')
)
const GoldenReceiptLandingPage = lazy(
  () => import('../pages/golden-receipt/GoldenReceiptLandingPage')
)
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const cashflowAdminRouter = (
  <DomainRoute route="app-admin-cashflow">
    <DashSwitch>
      <DomainRoute
        exact
        route="app-admin-cashflow-price-audit-landing"
        component={CashflowPriceAuditLandingPage}
        accessControl={cashflowPriceAuditControl}
      />
      <DomainRoute
        exact
        route="app-admin-cashflow-price-audit-feedback"
        component={CashflowPriceAuditFeedbackPage as ComponentType<any>}
      />
      <DomainRoute
        exact
        route="app-admin-cashflow-price-audit-details"
        component={CashflowPriceAuditDetailsPage as ComponentType<any>}
        accessControl={cashflowPriceAuditControl}
      />
      <DomainRoute
        exact
        route="app-admin-cashflow-checkout-discrepancy-audit-landing"
        component={CashflowCheckoutDiscrepancyLandingPage}
      />
      <DomainRoute
        exact
        route="app-admin-cashflow-checkout-discrepancy-audit-details"
        component={CashflowCheckoutDiscrepancyDetailsPage as ComponentType<any>}
        accessControl={cashflowCheckoutDiscrepancyAuditControl}
      />
      <DomainRoute
        exact
        route="app-admin-cashflow-transaction-integrity-audit"
        component={TransactionIntegrityLandingPage}
        accessControl={cashflowTransactionIntegrityAuditControl}
      />
      <DomainRoute
        exact
        route="app-admin-cashflow-golden-receipt"
        component={GoldenReceiptLandingPage}
        accessControl={cashflowPriceAuditControl}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
